import React from "react";
import { Card, CardBody } from "reactstrap";
import CptShimmerBlock from "../common/CptShimmerBlock";
import ComponentPerformanceCardShimmer from "./ComponentPerformanceCardShimmer";

const CPTCodePerformanceShimmer = () => (
  <div className="mpr-shimmer-wrap cpt-perf-shimmer-wrap" aria-busy="true" aria-label="Loading report">
    <Card className="chart-card-modern">
      <CardBody>
        <div className="chart-header-modern">
          <CptShimmerBlock className="mpr-shimmer-icon-block" />
          <div className="chart-header-copy-modern">
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
            <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--subtitle" />
          </div>
        </div>
        <div className="component-performance-grid">
          <ComponentPerformanceCardShimmer variant="standard" />
          <ComponentPerformanceCardShimmer variant="standard" />
          <ComponentPerformanceCardShimmer variant="standard" />
          <ComponentPerformanceCardShimmer variant="enrollment" />
        </div>
      </CardBody>
    </Card>
  </div>
);

export default CPTCodePerformanceShimmer;
